<template>
  <div class="flex flex-col w-full side-pack-in">
    <div class="flex flex-col space-y-2 w-full h-full jcs pack-area p-8">
      <div class="flex flex-col pack-height overflow-scroll">
        <slick
          ref="slick"
          :options="slickOptions"
          class="w-full"
          @swipe="handleSwipe"
          v-if="productPackages && productPackages.length"
        >
          <div
            ref="item"
            v-for="(productPackage, i) in productPackages"
            :key="i"
            class="overflow-hidden"
          >
            <div class="flex flex-col w-full">
              <div class="text-center w-full">
                <div class="flex flex-wrap aic jcb border-b border-gray-100 mb-6 pb-3">
                  <h2 class="text-sm capitalize text-dark">
                    {{
                      productPackage.question
                        ? productPackage.question
                        : productPackage.name
                    }}
                  </h2>
                  <div class="flex aic jce sm:ml-auto">
                    <span class="fs-14 mr-3">
                      Min :
                      <b class="text-primary-color">{{ productPackage.min }}</b>
                    </span>
                    <span class="fs-14">
                      Max :
                      <b class="text-primary-color">{{ productPackage.max }}</b>
                    </span>
                  </div>
                </div>
              </div>
              <div class="flex flex-col jcs pt-4 pb-0 pack-btn-area relative">
                <button
                  v-for="(item, i) in productPackage.product"
                  :key="i"
                  type="button"
                  @click="addToSelectedPackage(item, productPackage)"
                  :class="{
                    'filter grayscale-0 text-primary-color': selectedProducts.find(
                      (f) => f.productId == item.id
                    ),
                    'filter grayscale opacity-60': !selectedProducts.find(
                      (f) => f.productId == item.id
                    ),
                    'cursor-not-allowed	':
                      selectedProducts.length >= productPackage.max &&
                      !selectedProducts.find((f) => f.productId == item.id),
                  }"
                  :disabled="
                    selectedProducts.length >= productPackage.max &&
                    !selectedProducts.find((f) => f.productId == item.id)
                  "
                  class="flex aic jcb space-x-3 py-1 pack-btn w-full mb-1"
                >
                  <img
                    class="w-40p h-40p object-cover"
                    :src="item.image ? storageUrl + item.image : '/dish.webp'"
                    :alt="item.name"
                  />
                  <span class="text-xs md:text-sm mb-1 pl-4 flex flex-grow text-left">{{ item.name }}</span>
                  <div class="fs-11 w-90p text-right">{{ currency }} {{ item.price }}</div>
                  <div
                    class="rounded-md w-30p h-30p flex aic jcc fs-20"
                    :class="{
                      'bg-white': selectedProducts.find(
                        (f) => f.productId == item.id
                      ),
                      'bg-gray-100': !selectedProducts.find(
                        (f) => f.productId == item.id
                      )
                    }"
                  >
                    <i
                      class="fa fa-check"
                      :class="{
                        'block text-green': selectedProducts.find(
                          (f) => f.productId == item.id
                        ),
                        'hidden': !selectedProducts.find(
                          (f) => f.productId == item.id
                        )
                      }"
                    ></i>
                  </div>
                </button>
              </div>
              <div class="pack-btn-overlay"></div>
            </div>
          </div>
        </slick>
      </div>
    </div>

    <div
      class="flex aic mt-auto bg-secondary att-btn absolute bottom-0 left-0 w-full"
      :class="showPrev && productPackages.length > 1 ? 'jcb' : 'jce'"
    >
      <button
        type="button"
        @click="prev"
        v-if="showPrev && productPackages.length > 1"
        class="inline-flex jcc aic max-w-max text-md lg:text-lg relative px-10 py-3 text-primary-dark"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4 mr-2"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 19l-7-7 7-7"
          />
        </svg>
        {{ $t('Back') }}
      </button>
      <button
        type="button"
        v-if="!(canGoNext && productPackages.length > 1)"
        @click="addSteps"
        :class="{
          'text-white filter grayscale':
            canGoNext && productPackages.length > 1,
        }"
        class="inline-flex jcc aic text-md lg:text-lg relative w-130p att-btn bg-primary-dark text-white"
      >
        {{ $t('Add') }}
      </button>
      <button
        type="button"
        @click="next"
        v-else
        class="inline-flex jcc aic text-md lg:text-lg relative w-150p att-btn bg-primary-dark text-white"
      >
        {{ $t('Further') }}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-6 ml-2"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 5l7 7-7 7"
          />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import Slick from "vue-slick";
import "slick-carousel/slick/slick.css";
export default {
  components: {
    Slick,
  },
  props: ["attributes", "currency", "storageUrl", "product"],
  data() {
    return {
      level: "Packages",
      selectedProducts: [],
      totalSelectedProduct: [],
      canGoNext: true,
      showPrev: false,
      slickOptions: {
        prevArrow: "",
        nextArrow: "",
        dots: false,
        infinite: false,
        draggable: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 6000,
        swipe: false,
      },
    };
  },
  computed: {
    restaurantId() {
      return process.env.VUE_APP_RESTAURANT_ID;
    },
    productPackages() {
      const prioritiesList =
        this.$store.state.orderiomApiPackage.product.productPackage.map((m) => {
          return m.priority;
        });
      if (prioritiesList.every((item) => !item)) {
        const productPackages = [
          ...this.$store.state.orderiomApiPackage.product.productPackage,
        ];
        return productPackages;
      } else {
        const productPackages = [
          ...this.$store.state.orderiomApiPackage.product.productPackage,
        ].sort((a, b) => (a.priority > b.priority ? 1 : -1));
        return productPackages;
      }
    },
  },

  methods: {
    ShowAlertDialog(msg) {
      this.alertDialog = true;
      this.msg = msg;
      setTimeout(() => {
        this.alertDialog = false;
      }, 2000);
    },

    next() {
      //last stp
      if (this.$refs.slick.currentSlide() + 1 == this.productPackages.length) {
        return;
      }
      // min controller
      if (
        this.productPackages[this.$refs.slick.currentSlide()].min >
        this.selectedProducts.length
      ) {
        this.$emit(
          "showAlertDialog",
          `${"you have to select at least"} ${
            this.productPackages[this.$refs.slick.currentSlide()].min
          } ${"products"}`
        );
      } else if (
        this.productPackages[this.$refs.slick.currentSlide()].min <=
        this.selectedProducts.length
      ) {
        this.showPrev = true;

        if (
          this.$refs.slick.currentSlide() + 2 ==
          this.productPackages.length
        ) {
          this.canGoNext = false;
        }
        const totalSelectedProduct = this.totalSelectedProduct.concat(
          this.selectedProducts
        );
        this.totalSelectedProduct = Array.from(
          new Set(totalSelectedProduct.map((a) => a.productId))
        ).map((productId) => {
          return totalSelectedProduct.find((a) => a.productId === productId);
        });
        this.selectedProducts = [];
        this.$refs.slick.next();
      }
    },
    prev() {
      if (this.$refs.slick.currentSlide() == 1) {
        this.showPrev = false;
      }
      this.selectedProducts = [];
      this.canGoNext = true;
      this.productPackages[this.$refs.slick.currentSlide() - 1].product.map(
        (f) => {
          this.totalSelectedProduct.map((m) => {
            if (m.productId === f.id) {
              this.selectedProducts.push({
                productId: f.id,
                productPackage:
                  this.productPackages[this.$refs.slick.currentSlide() - 1].id,
              });
            }
          });
          this.selectedProducts = Array.from(
            new Set(this.selectedProducts.map((a) => a.productId))
          ).map((productId) => {
            return this.selectedProducts.find((a) => a.productId === productId);
          });
        }
      );
      this.$refs.slick.prev();
    },

    removeElement(array, elem) {
      var index = array.indexOf(elem);
      if (index > -1) {
        array.splice(index, 1);
      }
    },
    addToSelectedPackage(product, selectedProducts) {
      if (this.selectedProducts.find((f) => f.productId == product.id)) {
        this.selectedProducts.map((f) => {
          if (f.productId == product.id) {
            this.removeElement(this.selectedProducts, f);
            if (
              this.totalSelectedProduct.find((p) => p.productId == product.id)
            ) {
              let productTodelete = this.totalSelectedProduct.find(
                (p) => p.productId == product.id
              );
              this.removeElement(this.totalSelectedProduct, productTodelete);
            }
          }
        });
      } else {
        this.selectedProducts.push({
          productId: product.id,
          productPackage: selectedProducts.id,
        });
      }
    },
    addSteps() {
      if (this.$refs.slick.currentSlide() + 1 == this.productPackages.length) {
        if (
          this.productPackages[this.$refs.slick.currentSlide()].min >
          this.selectedProducts.length
        ) {
          this.$emit(
            "showAlertDialog",
            `${"you have to select at least"} ${
              this.productPackages[this.$refs.slick.currentSlide()].min
            } ${"products"}`
          );
          return;
        }
        this.totalSelectedProduct = this.totalSelectedProduct.concat(
          this.selectedProducts
        );
      }
      this.$store
        .dispatch("order/addProductPackageItem", {
          restaurantId: this.restaurantId,
          productId: this.product.id,
          quantity: 1,
          productItems: this.totalSelectedProduct,
        })
        .then((res) => {
          if (res.type == "success") {
            this.$emit("close");
            this.$emit("showCart");
          }
        });
    },
    handleSwipe(event, slick, direction) {
      console.log(slick);
      if (direction == "left") {
        //last stp
        if (
          this.$refs.slick.currentSlide() + 1 ==
          this.productPackages.length
        ) {
          // return;
          event.preventDefault();
        }
        // min controller
        if (
          this.productPackages[this.$refs.slick.currentSlide()].min >
          this.selectedProducts.length
        ) {
          this.$emit(
            "showAlertDialog",
            `${"you have to select at least"} ${
              this.productPackages[this.$refs.slick.currentSlide()].min
            } ${"products"}`
          );
        } else if (
          this.productPackages[this.$refs.slick.currentSlide()].min <=
          this.selectedProducts.length
        ) {
          this.showPrev = true;

          if (
            this.$refs.slick.currentSlide() + 2 ==
            this.productPackages.length
          ) {
            this.canGoNext = false;
          }
          const totalSelectedProduct = this.totalSelectedProduct.concat(
            this.selectedProducts
          );
          this.totalSelectedProduct = Array.from(
            new Set(totalSelectedProduct.map((a) => a.productId))
          ).map((productId) => {
            return totalSelectedProduct.find((a) => a.productId === productId);
          });
          this.selectedProducts = [];
          this.$refs.slick.next();
        }
      } else this.prev();
    },
  },
  beforeDestroy() {
    this.$refs.slick.$destroy();
    this.$store.commit("product/setProductPackage", null);
  },
};
</script>

<style>
.menu-arrows {
  display: block;
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
}
.menu-arrows__btn {
  width: 50px;
  height: 50px;
  position: absolute;
  font-size: 18px;
  font-weight: 700;
  padding: 4px;
  border: 1px solid white;
  border-radius: 50%;
}
.menu-arrows__btn i {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
}
.menu-arrows__btn--left {
  left: 0px;
}
.menu-arrows__btn--left i {
  right: 20px;
}
.menu-arrows__btn--right {
  right: 0px;
}
.menu-arrows__btn--right i {
  left: 20px;
}
.menu-arrows__btn.slick-disabled {
  opacity: 0.5;
  pointer-events: none !important;
  cursor: not-allowed !important;
}
</style>
